export default {
    state: {
        token: '',
        userInfo: null,
        outflag: true,
        phone: "",
        studentPaperInfo: {
            paperName: "",
            paperScore: 100,
            paperDuration: 0
        },

        studentLineData:[],
    },
    getters: {
        // 获取试卷信息
        GetstudentPaperInfo: state => {
            return state.studentPaperInfo

        },
        GetStudentLineData: state => {
            return state.studentLineData

        },

        
        // 退出是否刷新
        Getoutflag: state => {
            return state.outflag

        },
        // 获取权限信息
        GetAuthority: state => {
            if (state.userInfo == null && window.localStorage.getItem("userinfo")) {
                state.userInfo = JSON.parse(window.localStorage.getItem("userinfo"))
                return state.userInfo.roleInfos
            }
            if (state.userInfo != null)
                return state.userInfo.roleInfos
            return []
        },
        // 获取用户信息
        GetUserInfo: state => {
            if (state.userInfo == null && window.localStorage.getItem("userinfo")) {
                state.userInfo = JSON.parse(window.localStorage.getItem("userinfo"))
            }
            return state.userInfo
        },
        Getrecordphone: state => {
            if (state.phone == null && window.localStorage.getItem("phone")) {
                state.phone = JSON.parse(window.localStorage.getItem("phone"))
            }
            return state.phone
        },
        //获取预配评分标准
        getYpPfbz: state => {
            return JSON.parse(state.studentPaperInfo.ypJson)
        },
        //获取轮次评分标准
        getLcPfbz: state => {
            return JSON.parse(state.studentPaperInfo.roundJson)
        },

    },
    mutations: {
        SetStudentLineData(state, _studentLineData) {
            state.studentLineData = _studentLineData;
        },
        
        SetStudentPaperInfo(state, studentPaperInfo) {
            state.studentPaperInfo = studentPaperInfo;
        },

        Setoutflag(state, outflag) {
            state.outflag = outflag;
        },
        // 登录
        Login(state, userInfo) {
            console.log(userInfo)
            state.token = userInfo.token
            state.userInfo = userInfo;
            window.localStorage.setItem("token", userInfo.token)
            window.localStorage.setItem("userinfo", JSON.stringify(userInfo))
        },

        recordphone(state, phone) {
            state.phone = phone;
            window.localStorage.setItem("phone", phone)
        },
        // 登出
        LoginOut(state) {
            //  window.localStorage.clear();
            window.localStorage.removeItem("userinfo")
            window.localStorage.removeItem("token")
        },
    }


}


// WEBPACK FOOTER //
// ./src/store/login.js